module.exports = __webpack_public_path__ + "assets/95094607984fe4a7d5b40092897a4aee.png";